<template>
	<div
		class="mlp-root"
		:class="{ expanded: isExpanded }"
		@mouseenter="localExpanded = true"
		@mouseleave="onSidebarLeave"
	>
		<section class="mlp-topcard d-flex flex-column">
			<img
				src="../../assets/NewDashboard/shadowpng.png"
				class="topcard-img-shadow"
				alt=""
			/>
			<!-- Top row: avatar + arrow button -->
			<div
				class="topcard-header d-flex justify-content-between align-items-center"
			>
				<div class="avatar-wrapper">
					<svg class="progress-ring" width="40" height="40" viewBox="0 0 40 40">
						<circle class="ring-bg" cx="20" cy="20" r="17" />
						<circle
							class="ring-fill"
							cx="20"
							cy="20"
							r="17"
							:stroke-dasharray="`${2 * Math.PI * 17}`"
							:stroke-dashoffset="`${
								2 * Math.PI * 17 * (1 - profileCompletion / 100)
							}`"
						/>
					</svg>
					<img class="avatar-img" :src="user.avatar" :alt="user.name" />
					<div class="completion-badge">{{ profileCompletion }}%</div>
				</div>

				<img
					class="pointer"
					v-if="isExpanded"
					src="../../assets/NewDashboard/roundedarw.svg"
					alt=""
					@click="goToResumeBuilder"
				/>
			</div>

			<!-- User info -->
			<div v-if="isExpanded" class="topcard-info">
				<h2 class="user-name m-0">
					{{ user.name }}
				</h2>
				<p class="user-role w-100 text-truncate">
					{{ user.role }}
				</p>
			</div>
			<!-- <div class="company-badge-container pb-2">
				<div class="company-badge d-flex align-items-center">
					<img src="../../assets/NewDashboard/googleicon.svg" alt="" />
					Google
				</div>
			</div> -->
			<!-- Complete profile banner: only shown when profile completion < 70% -->

			<!-- Complete profile banner -->
			<div
				v-if="isExpanded && showCompleteProfile"
				class="complete-banner text-center"
			>
				Complete your profile
			</div>
		</section>
		<section class="sidebar-nav">
			<!-- Group 1 -->
			<div v-for="item in navGroup1" :key="item.label" class="mlp-nav-wrap">
				<template v-if="!item.children">
					<div
						:key="'link-' + item.label"
						:class="[
							'mlp-sidebar-inactive fam-inter fw-R fs-15 d-flex align-items-center',
							{
								'mlp-sidebar-active': isActive(item),
								expanded: isExpanded,
								'mlp-logout': item.logout,
							},
						]"
						:data-route="item.routeName"
						@click="handleNav(item)"
					>
						<img
							v-if="item.icon"
							:src="activeIcon(item) ? item.iconActive : item.icon"
							:alt="item.label"
							class="sidebar-icon"
						/>

						<span v-if="isExpanded" class="mlp-label">{{ item.label }}</span>
						<span v-if="item.badge && isExpanded" class="sidebar-badge">{{
							item.badge
						}}</span>
					</div>
				</template>

				<!-- Collapsible parent (Resume) -->
				<template v-else>
					<div :key="'collapse-' + item.label" class="mlp-sidebar-collapse">
						<div
							:class="[
								'mlp-sidebar-inactive fam-inter fw-R fs-15 d-flex align-items-center mlp-collapse-toggle',
								{
									'mlp-sidebar-active': isActive(item),
									expanded: isExpanded,
								},
							]"
							@click="toggleCollapse(item)"
						>
							<img
								:src="isActive(item) ? item.iconActive : item.icon"
								:alt="item.label"
								class="sidebar-icon"
							/>
							<span v-if="isExpanded" class="mlp-label">{{ item.label }}</span>
							<img
								v-if="isExpanded"
								:src="
									isOpen(item)
										? require('@/assets/sidebar/sidebarUpArrow.svg')
										: require('@/assets/sidebar/sidebardownarrow.svg')
								"
								alt="toggle"
								class="mlp-caret"
							/>
						</div>

						<!-- Sub-items (Create Resume / Fix my resume) -->
						<transition name="mlp-fade">
							<div
								v-if="isExpanded && isOpen(item)"
								class="mlp-submenu"
								:class="{ 'mlp-submenu-inactive': !hasActiveChild(item) }"
							>
								<div
									v-for="child in item.children"
									:key="child.label"
									:class="[
										'mlp-submenu-item fam-inter fw-R fs-15 d-flex align-items-center gap-2',
										{ 'mlp-sidebar-active': isActive(child) },
									]"
									@click="handleChildNav(item, child)"
								>
									<img
										:src="activeIcon(child) ? child.iconActive : child.icon"
										:alt="child.label"
										class="sidebar-icon submenu-icon"
									/>
									<span>{{ child.label }}</span>
								</div>
							</div>
						</transition>
					</div>
				</template>
			</div>
			<div class="sidebar-divider"></div>
			<!-- Group 2: My Documents / Account Settings / Logout -->
			<div
				v-for="item in navGroup2"
				:key="'bottom-' + item.label"
				:data-route="item.routeName"
				:class="[
					'mlp-sidebar-inactive fam-inter fw-R fs-15 d-flex align-items-center',
					{
						'mlp-sidebar-active': isActive(item),
						expanded: isExpanded,
						'mlp-logout': item.logout,
					},
				]"
				@click="handleNav(item)"
			>
				<img
					v-if="item.icon"
					:src="activeIcon(item) ? item.iconActive : item.icon"
					:alt="item.label"
					class="sidebar-icon"
				/>

				<span v-if="isExpanded" class="mlp-label">{{ item.label }}</span>
				<span v-if="item.badge && isExpanded" class="sidebar-badge">{{
					item.badge
				}}</span>
			</div>
		</section>
		<LogoutConfirmModal
			:visible="showLogoutModal"
			@confirm="confirmLogout"
			@cancel="cancelLogout"
		/>
		<ResumeClinicModal
			v-if="showResumeClinicModal"
			:showModal="showResumeClinicModal"
			@modalClose="closeResumeClinicModal"
			:showfromhelpsection="false"
			:clinicDatafromhs="resumeClinicData"
		/>
	</div>
</template>

<script>
import LogoutConfirmModal from "../../components/BuilderPage/Cards/LogoutConfirmModal.vue";
import ResumeClinicModal from "../../components/BuilderPage/ResumeclinicModal.vue";
import { config } from "@/config/index.js";
import { mapGetters } from "vuex";
import EventBus from "@/utils/EventBus";
import {
	getProfileCompletion,
	getCandidatePrimaryProfile,
	getCandInfo,
	resumeAnalysis,
} from "@/utils/apiFunctions.js";
export default {
	props: {
		expanded: {
			type: Boolean,
			default: null,
		},
	},
	data() {
		return {
			showLogoutModal: false,
			showResumeClinicModal: false,
			// Whether the "Fix my resume" (Resume Clinic) modal is currently open.
			// "Fix my resume" does not navigate — it opens the modal in place — so we
			// use this flag to keep that sidebar child highlighted while it is open.
			fixResumeModalOpen: false,
			// Resume mode ("create"/"fix") selected before the "Fix my resume" modal
			// was opened, so closing the modal can restore the previous active child.
			resumeModeBeforeFix: null,
			// Snapshot of which collapsible submenus were open before the "Fix my
			// resume" modal opened. Restored on close so submenus like "Find Jobs"
			// that got collapsed by the accordion reappear.
			openStateBeforeFixModal: null,
			resumeClinicData: {},
			localExpanded: false,
			selectedResumeMode: "create",
			selectedJobMode: "search",

			navGroup1: [
				{
					label: "Home",
					icon: require("@/assets/NewDashboard/sidebar/home.svg"),
					iconActive: require("@/assets/NewDashboard/sidebar/activehome.svg"),
					routeName: "Homepage",
				},
				{
					label: "Resume",
					icon: require("@/assets/NewDashboard/sidebar/resume.svg"),
					iconActive: require("@/assets/NewDashboard/sidebar/activeresume.svg"),
					open: false,

					activeFor: ["MobilePreviewResume"],
					children: [
						{
							label: "Create Resume",
							icon: require("@/assets/NewDashboard/sidebar/createresume.svg"),
							iconActive: require("@/assets/NewDashboard/sidebar/activecreateresume.svg"),
							routeName: "CandidateDashboard",
							mode: "create",
						},
						{
							label: "Fix my resume",
							icon: require("@/assets/NewDashboard/sidebar/fixresume.svg"),
							iconActive: require("@/assets/NewDashboard/sidebar/activefixresume.svg"),
							routeName: "CandidateDashboard",
							mode: "fix",
						},
					],
				},
				{
					label: "Skill Tests",
					icon: require("@/assets/NewDashboard/sidebar/skilltest.svg"),
					iconActive: require("@/assets/NewDashboard/sidebar/activeskilltest.svg"),
					routeName: "AssessmentMarketplace",

					activeFor: [
						"AssessmentMarketplace",
						"CandidateAssessmentProgress",
						"TestDetails",
						"GuestTestDetails",
						"mobAssessment",
						"mobViewMarks",
						"AssessmentReport",
						"Leaderboard",
					],
				},
				{
					label: "Practice Interviews",
					icon: require("@/assets/NewDashboard/sidebar/practiceinterview.svg"),
					iconActive: require("@/assets/NewDashboard/sidebar/activepracticeinterview.svg"),
					routeName: "InterviewKickstart",

					activeFor: [
						"InterviewKickstart",
						"PrepareInterview",
						"InterviewSkills",
						"TakeAiInterview",
						"AiSkillInterview",
						"InterviewOngoing",
						"ReportAiInterview",
						"Report",
						"systemcheck",
						"snapshot",
						"previewvideoresume",
					],
				},
				// {
				// 	label: "Get Verified",
				// 	icon: require("@/assets/NewDashboard/sidebar/getverified.svg"),
				// 	iconActive: require("@/assets/NewDashboard/sidebar/activegetverified.svg"),
				// 	badge: "NEW",
				// },
				{
					label: "Learn & Upskill",
					icon: require("@/assets/NewDashboard/sidebar/learnupskill.svg"),
					iconActive: require("@/assets/NewDashboard/sidebar/activelearnupskill.svg"),
					open: false,
					children: [
						{
							label: "Marketplace",
							icon: require("@/assets/NewDashboard/sidebar/marketplace.svg"),
							iconActive: require("@/assets/NewDashboard/sidebar/activemarketplace.svg"),
							trainingPath: "/marketplace",
						},
						{
							label: "Dashboard",
							icon: require("@/assets/NewDashboard/sidebar/tdashboard.svg"),
							iconActive: require("@/assets/NewDashboard/sidebar/activetdashboard.svg"),
							trainingPath: "/dashboard",
						},
						{
							label: "Community",
							icon: require("@/assets/NewDashboard/sidebar/community.svg"),
							iconActive: require("@/assets/NewDashboard/sidebar/activecommunity.svg"),
							trainingPath: "/community",
						},
						{
							label: "Certificates",
							icon: require("@/assets/NewDashboard/sidebar/certificates.svg"),
							iconActive: require("@/assets/NewDashboard/sidebar/activecertificate.svg"),
							trainingPath: "/certificate",
						},
					],
				},
				{
					label: "Find Jobs",
					icon: require("@/assets/NewDashboard/sidebar/jobs.svg"),
					iconActive: require("@/assets/NewDashboard/sidebar/activejobs.svg"),
					open: false,

					activeFor: ["GuestJobDetails", "JobMatch", "JobPreference"],
					children: [
						{
							label: "Job Search",
							icon: require("@/assets/NewDashboard/sidebar/findjobs.svg"),
							iconActive: require("@/assets/NewDashboard/sidebar/activefindjobs.svg"),
							routeName: "JobSearch",
							jobMode: "search",
							activeFor: ["GuestJobDetails"],
						},
						{
							label: "Applied Jobs",
							icon: require("@/assets/NewDashboard/sidebar/applyjobs.svg"),
							iconActive: require("@/assets/NewDashboard/sidebar/activeapplyjobs.svg"),
							routeName: "JobProgress",
							jobMode: "applied",
						},
						{
							label: "Saved Jobs",
							icon: require("@/assets/NewDashboard/sidebar/savedjobs.svg"),
							iconActive: require("@/assets/NewDashboard/sidebar/activesavejobs.svg"),
							routeName: "JobSearch",
							jobMode: "saved",
						},
					],
				},
			],
			navGroup2: [
				{
					label: "My Documents",
					icon: require("@/assets/NewDashboard/sidebar/mydocs.svg"),
					iconActive: require("@/assets/NewDashboard/sidebar/activemydocs.svg"),
					routeName: "CandidateDocsList",
					activeFor: ["CandidateDocsList", "OnboardingDocuments"],
				},
				{
					label: "Account Settings",
					icon: require("@/assets/NewDashboard/sidebar/accountsettings.svg"),
					iconActive: require("@/assets/NewDashboard/sidebar/activeaccountsetting.svg"),
					routeName: "MainProfile",
					activeFor: ["MainProfile", "ProfileVisibility", "AccountDisabled"],
				},
				{
					label: "Logout",
					icon: require("@/assets/NewDashboard/sidebar/logout.svg"),
					iconActive: require("@/assets/NewDashboard/sidebar/logout.svg"),
					logout: true,
				},
			],
		};
	},
	watch: {
		"$route.name"() {
			this.syncOpenToRoute();
		},
	},
	components: {
		LogoutConfirmModal,
		ResumeClinicModal,
	},
	mounted() {
		this.navGroup1.forEach((item) => {
			if (item.children) item.open = this.hasActiveChild(item);
		});
		window.addEventListener("pageshow", this.onPageShow);
		window.addEventListener("popstate", this.onPopState);
	},
	beforeDestroy() {
		EventBus.$off("login-success", this.createdActions);
		EventBus.$off("onboarding-fetch-post-login", this.createdActions);
		window.removeEventListener("pageshow", this.onPageShow);
		window.removeEventListener("popstate", this.onPopState);
	},
	async created() {
		EventBus.$on("login-success", this.createdActions);
		EventBus.$on("onboarding-fetch-post-login", this.createdActions);
		await this.createdActions();
	},
	computed: {
		...mapGetters("candidateVUEX", {
			progress: "getCandProgressResp",
			candidateInfo: "getcandidateInfo",
		}),
		// Profile completion percentage from the progress API (already stored in Vuex)
		profileCompletion() {
			const p = this.progress?.progress;
			if (typeof p === "number") return p;
			const c = this.candidateInfo || {};
			return typeof c.progress === "number"
				? c.progress
				: typeof c.profileProgress === "number"
				? c.profileProgress
				: 0;
		},
		// Name, image and designation of the person, fetched from Vuex store
		user() {
			const c = this.candidateInfo || {};
			const name =
				c.fullName ||
				(c.firstName && c.lastName
					? `${c.firstName} ${c.lastName}`
					: c.firstName || c.lastName || c.name || "Candidate");
			return {
				name,
				role: c.designation || c.experienceLevelFormatted || c.role || " ",
				avatar: c.image || c.profileImage || c.avatar || "",
			};
		},
		showCompleteProfile() {
			return this.profileCompletion < 70;
		},
		isExpanded() {
			return this.expanded !== null ? this.expanded : this.localExpanded;
		},

		isHomePage() {
			return this.$route && this.$route.name === "Homepage";
		},
	},

	methods: {
		async createdActions() {
			try {
				const response = await getCandInfo(this.$route.query.id);
				let localCandidateInfo = null;
				if (response.status === 200) {
					localCandidateInfo = response.data.data;
				} else if (response.status === 404) {
					const res2 = await getCandidatePrimaryProfile();
					localCandidateInfo = res2.data.data;
				}
				if (localCandidateInfo) {
					this.$store.commit(
						"candidateVUEX/setCandidateInfo",
						localCandidateInfo
					);
				}
			} catch (error) {
				console.error(error);
			}
			this.fetchProfileProgress();
		},
		goToResumeBuilder() {
			this.$router.push({ name: "CandidateDashboard" }).catch(() => {});
		},
		async fetchProfileProgress() {
			try {
				const candId = this.candidateInfo?._id;
				const res = await getProfileCompletion(candId);
				if (res.status === 200 && res.data?.data) {
					this.$store.commit(
						"candidateVUEX/updateCandidateProgress",
						res.data.data
					);
				}
			} catch (error) {
				console.error(error);
			}
		},
		confirmLogout() {
			this.$store.commit("candidateVUEX/setResclinicRename", false);
			localStorage.clear();
			this.$store.dispatch("userVUEX/LogOut");
			this.allProfileList = [];
		},
		cancelLogout() {
			this.showLogoutModal = false;
		},
		// "Fix my resume" opens the Resume Clinic modal directly (no redirect)
		openResumeClinicModal() {
			this.fixResumeModalOpen = true;
			this.fetchResumeClinicData().finally(() => {
				this.showResumeClinicModal = true;
			});
		},
		async fetchResumeClinicData() {
			try {
				const res = await resumeAnalysis();
				if (res.status === 200) {
					this.resumeClinicData = res.data?.data?.analysis || {};
				}
			} catch (error) {
				console.error(error);
			}
		},
		closeResumeClinicModal() {
			this.showResumeClinicModal = false;
			this.fixResumeModalOpen = false;

			if (this.resumeModeBeforeFix) {
				this.selectedResumeMode = this.resumeModeBeforeFix;
				this.resumeModeBeforeFix = null;
			}

			if (this.openStateBeforeFixModal) {
				this.openStateBeforeFixModal.forEach((s) => {
					const item = this.navGroup1.find((i) => i.label === s.label);
					if (item) item.open = s.open;
				});
				this.openStateBeforeFixModal = null;
				this.syncPin();
			}
		},
		toggleCollapse(item) {
			item.open = !item.open;
			this.syncPin();
		},

		syncOpenToRoute() {
			let changed = false;
			this.navGroup1.forEach((item) => {
				if (!item.children) return;
				const shouldOpen = this.hasActiveChild(item);
				if (item.open !== shouldOpen) {
					item.open = shouldOpen;
					changed = true;
				}
			});
			if (changed) this.syncPin();
		},

		isOpen(item) {
			return !!item.open;
		},

		onSidebarLeave() {
			this.localExpanded = false;

			if (this.isHomePage) return;
			this.collapseInactiveMenus();
		},

		onPageShow(event) {
			if (!event.persisted) return;
			this.collapseInactiveMenus();
		},
		onPopState() {
			this.collapseInactiveMenus();
		},

		collapseInactiveMenus() {
			let changed = false;
			this.navGroup1.forEach((item) => {
				if (item.children && this.isOpen(item) && !this.hasActiveChild(item)) {
					item.open = false;
					changed = true;
				}
			});
			if (changed) this.syncPin();
		},

		syncPin() {
			const anyOpen = this.navGroup1.some(
				(item) => item.children && this.isOpen(item)
			);

			this.$emit("set-expanded", anyOpen);
		},

		handleChildNav(parent, child) {
			const isFixModal =
				child.routeName === "CandidateDashboard" && child.mode === "fix";
			if (isFixModal) {
				this.openStateBeforeFixModal = this.navGroup1
					.filter((item) => item.children)
					.map((item) => ({ label: item.label, open: item.open }));
			}

			this.navGroup1.forEach((item) => {
				if (item.children) item.open = item === parent;
			});
			this.handleNav(child);
			this.syncPin();
			this.$emit("navigate");
		},
		isActive(item) {
			const activeFor = item.activeFor || [];
			if (this.$route && activeFor.includes(this.$route.name)) return true;
			// Route-based active only (drives the active pill background/color)
			if (item.children) {
				const names = item.children.map((c) => c.routeName).filter(Boolean);
				if (this.$route && names.includes(this.$route.name)) return true;
				// "Fix my resume" opens a modal instead of navigating, so only the
				// parent that actually OWNS the "fix" child (the Resume group) counts
				// as active while that modal is open — not the other groups.
				const ownsFixChild = item.children.some((c) => c.mode === "fix");
				if (ownsFixChild && this.fixResumeModalOpen) return true;
			}
			// Find Jobs sub-items: Job Search & Saved Jobs share the "JobSearch"
			// route, so only the one the user actually selected stays highlighted.
			if (item.jobMode) {
				if (!this.$route || this.$route.name !== item.routeName) return false;

				if (item.jobMode === "applied") return true;
				const isSavedQuery =
					this.$route.query.bookmarked === "true" ||
					this.$route.query.screen === "saved-jobs";
				return item.jobMode === "saved" ? isSavedQuery : !isSavedQuery;
			}

			if (item.mode) {
				if (item.mode === "fix" && this.fixResumeModalOpen) return true;
				return (
					this.$route &&
					this.$route.name === item.routeName &&
					item.mode === this.selectedResumeMode
				);
			}
			return this.$route && this.$route.name === item.routeName;
		},
		hasActiveChild(item) {
			if (!item.children) return false;
			const names = item.children
				.map((c) => c.routeName)
				.concat(item.children.flatMap((c) => c.activeFor || []))
				.filter(Boolean);
			if (!names.length) return false;
			return !!(this.$route && names.includes(this.$route.name));
		},
		activeIcon(item) {
			// Only the route-based active item uses the active icon;
			// hovered items keep their normal icon.
			return this.isActive(item);
		},
		handleNav(item) {
			if (item.children) return;

			this.syncPin();
			this.$emit("navigate");

			if (item.logout) {
				this.logout();
				return;
			}

			if (!item.routeName && !item.trainingPath && !item.jobMode) return;
			// Learn & Upskill sub-items redirect to the external training app.
			if (item.trainingPath) {
				window.location.href = `${config.trainingBase}${item.trainingPath}`;
				return;
			}
			// Find Jobs sub-items that share the "JobSearch" route need a query to
			// distinguish Saved Jobs from Job Search.
			if (item.jobMode === "saved") {
				this.selectedJobMode = item.jobMode;
				this.$router.push({
					name: "JobSearch",
					query: {
						bookmarked: true,
						screen: "saved-jobs",
						from: "sidebar",
					},
				});
				return;
			}
			if (item.jobMode === "applied") {
				this.selectedJobMode = item.jobMode;
				this.$router.push({
					name: "JobProgress",
					query: {
						screen: "main-screen",
						from: "sidebar",
					},
				});
				return;
			}
			if (item.jobMode) this.selectedJobMode = item.jobMode;
			if (item.routeName === "trainingMarketplace") {
				window.open(`${config.trainingBase}/marketplace`, "_self");
				return;
			}
			// "Fix my resume" opens the Resume Clinic modal in place (no route
			// redirect). Remember the resume mode that was selected before this
			// click so that closing the modal restores the previous child as the
			// active one (e.g. if you were on "Create Resume", it becomes active
			// again). "Create Resume" (mode "create") navigates to the builder.
			if (item.routeName === "CandidateDashboard" && item.mode === "fix") {
				this.resumeModeBeforeFix = this.selectedResumeMode;
				this.selectedResumeMode = "fix";
				this.openResumeClinicModal();
				return;
			}
			if (item.mode) this.selectedResumeMode = item.mode;
			this.$router.push({ name: item.routeName });
		},
		logout() {
			this.showLogoutModal = true;
		},
	},
};
</script>

<style scoped>
.mlp-sidebar-inactive {
	padding: 11px 14px;
	height: 41px;
	color: #1e293b;
	cursor: pointer;
	border-radius: 10px;
	transition: background 0.15s;
	justify-content: center;
}
.mlp-sidebar-inactive:hover {
	background: #f3f3f3;
}
.mlp-sidebar-inactive.expanded {
	justify-content: flex-start;
}
.mlp-sidebar-active {
	background: rgba(83, 163, 253, 0.16) !important;
	color: #1d4ed8 !important;
	border-radius: 10px;
}
.mlp-logout {
	color: #ff0000 !important;
}
/* Collapsed + active: square background only behind the icon */
.mlp-root:not(.expanded) .mlp-sidebar-active {
	width: 35px;
	height: 35px;
	margin: 0 auto;
	padding: 0;
	border-radius: 8px;
	justify-content: center;
}
.mlp-label {
	white-space: nowrap;
	min-width: 0;
}
.sidebar-icon + .mlp-label {
	margin-left: 12px;
}
.expanded .mlp-label {
	margin-left: 12px;
}
.mlp-root {
	width: 64px;
	transition: width 0.18s ease;
}
.mlp-root.expanded {
	width: 240px;
}
.mlp-topcard {
	display: flex;
	flex-direction: column;
	align-items: center;
}
.mlp-root.expanded .mlp-topcard {
	align-items: stretch;
}
.mlp-root:not(.expanded) .mlp-topcard {
	background: transparent;
	border: none;
	box-shadow: none;
	margin-bottom: 0;
}
.mlp-root:not(.expanded) .topcard-img-shadow {
	display: none;
}
.mlp-root:not(.expanded) .topcard-header {
	padding: 0 0 6px 0;
	justify-content: center;
}
.sidebar-icon {
	width: 18px;
	height: 18px;
	object-fit: contain;
	flex-shrink: 0;
}
.submenu-icon {
	width: 16px;
	height: 16px;
}
.mlp-sidebar-collapse {
	display: flex;
	flex-direction: column;
}
.mlp-collapse-toggle {
	width: 100%;
}
.mlp-caret {
	width: 10px;
	height: 10px;
	margin-left: auto;
	object-fit: contain;
	flex-shrink: 0;
	opacity: 0.6;
}
.mlp-submenu {
	display: flex;
	flex-direction: column;
	gap: 2px;
	padding-left: 24px;
	padding-top: 2px;
	position: relative;
}
.mlp-root:not(.expanded) .mlp-submenu {
	display: none !important;
}
.mlp-submenu::before {
	content: "";
	position: absolute;
	left: 20px;
	top: 2px;
	bottom: 2px;
	border: 2px solid #e2e8f0;
	background: #e2e8f0;
	border-radius: 12px;
}
.mlp-submenu-item {
	padding: 8px 12px;
	height: 36px;
	border-radius: 8px;
	cursor: pointer;
	color: #1e293b;
	margin: 2px 5px;
	position: relative;
}
.mlp-submenu-item:hover {
	background: #f3f3f3;
}
/* Fill the connector segment for the active child */
.mlp-submenu-item.mlp-sidebar-active::before {
	content: "";
	position: absolute;
	left: -9px;
	top: -2px;
	bottom: 0px;
	border: 2px solid #4a7eff;
	border-radius: 12px;
	background: #4a7eff;
}
.mlp-fade-enter-active,
.mlp-fade-leave-active {
	transition: opacity 0.2s ease, max-height 0.25s ease, transform 0.25s ease;
	overflow: hidden;
	max-height: 220px;
	transform-origin: top;
}
.mlp-fade-enter,
.mlp-fade-leave-to {
	opacity: 0;
	max-height: 0;
	transform: translateY(-6px);
}
.mlp-fade-enter-to {
	opacity: 1;
	transform: translateY(0);
}
.sidebar-badge {
	margin-left: auto;
	padding: 2.5px 7px;
	background: #e2e8f0;
	border-radius: 5px;
	font-family: "Inter", sans-serif;
	font-style: normal;
	font-weight: 400;
	height: 19px;
	font-size: 10.5px;
	color: #475569;
}
.sidebar-divider {
	width: 100%;
	height: 2px;
	border: none;
	margin: 10px 0;
	background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='9' height='2'%3E%3Crect x='0' y='0' width='6' height='2' rx='1' fill='%23efefef'/%3E%3C/svg%3E");
	background-repeat: repeat-x;
	background-size: 9px 2px;
}
.mlp-topcard {
	background: linear-gradient(
		132.74deg,
		rgba(255, 255, 255, 0.1) -8.24%,
		rgba(121, 133, 164, 0.1) 74.01%
	);
	border: 1px solid rgba(38, 50, 56, 0.1);
	border-radius: 10px;
	overflow: hidden;
	padding: 0;
	position: relative;
	margin-bottom: 12px;
}
.topcard-img-shadow {
	position: absolute;
	top: 0;
	left: 0;
	height: 70px;
	width: 70px;
	opacity: 0.7;
}
.topcard-header,
.topcard-info,
.company-badge-container {
	padding: 12px 16px 0 16px;
}
/* Avatar + ring */
.avatar-wrapper {
	position: relative;
	width: 40px;
	height: 40px;
	display: flex;
	align-items: center;
	justify-content: center;
}

.progress-ring {
	position: absolute;
	top: 0;
	left: 0;
	transform: rotate(-90deg);
	transform-origin: center;
}

.ring-bg {
	fill: none;
	stroke: #d1d3d6;
	stroke-width: 4;
}

.ring-fill {
	fill: none;
	stroke: #047857;
	stroke-width: 4;
	stroke-linecap: round;
	transition: stroke-dashoffset 0.6s ease;
}

.avatar-img {
	width: 32px;
	height: 32px;
	border-radius: 50%;
	object-fit: cover;
	position: relative;
	z-index: 1;
}

.topcard-arrow {
	cursor: pointer;
}

.completion-badge {
	position: absolute;
	left: 50%;
	transform: translateX(-50%);
	padding: 0px 4px;
	width: 36px;
	height: 14.5px;
	top: 31px;
	background: #047857;
	border-radius: 5.98316px;
	z-index: 2;
	white-space: nowrap;
	font-family: "Montserrat", sans-serif;
	font-style: normal;
	font-weight: 500;
	font-size: 10px;
	color: #ffffff;
	text-align: center;
}

.user-name {
	font-family: "Montserrat", sans-serif;
	font-style: normal;
	font-weight: 700;
	font-size: 16px;
	color: #1f1f1f;
}

.user-role {
	font-family: "Montserrat", sans-serif;
	font-style: normal;
	font-weight: 600;
	font-size: 13px;
	color: #1f1f1f;
}

/* Company badge */
.company-badge {
	display: inline-flex;
	align-items: center;
	padding: 4px;
	background: #f7f9fb;
	font-family: "Montserrat", sans-serif;
	font-weight: 500;
	font-size: 12px;
	color: #4a7eff;
	width: fit-content;
	border-radius: 20px;
}

/* Complete profile banner */
.complete-banner {
	padding: 0 5.64478px;
	height: 19px;
	background: #e74341;
	font-family: "Inter", sans-serif;
	font-style: normal;
	font-weight: 400;
	font-size: 12px;
	color: #ffffff;
}
.topcard-info {
	width: 100%;
	min-width: 0;
}

.user-name {
	width: 100%;
	min-width: 0;
	margin: 0;

	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2;
	overflow: hidden;

	white-space: normal !important;
	word-break: break-all;
	overflow-wrap: normal;

	line-height: 22px;
	max-height: 44px;
}
@media (max-width: 1028px) {
	.mlp-root.expanded {
		width: 250px;
	}
}
</style>
